module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/proposal-report/proposal-grid/proposal-grid.component.css
// module id = ./src/app/landprocurement/proposal-report/proposal-grid/proposal-grid.component.css
// module chunks = main